import React from "react";
import { fmtUSDStrict } from "@/lib/format";
import { Warehouse } from "lucide-react";

/** Where the physical exposure sits and what it costs to keep it there. */
export const StorageNote = ({ storage, notionalUsd = 0 }) => {
  if (!storage) return null;
  const monthly = (notionalUsd * storage.monthly_rate_pct) / 100;

  return (
    <div className="rounded-xl border bg-secondary/60 p-3.5 space-y-1.5" data-testid="storage-note">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-muted-foreground">
        <Warehouse className="h-3.5 w-3.5" /> Storage &amp; custody
      </div>
      <div className="text-sm leading-relaxed">
        Held as <span className="font-semibold">{storage.form}</span> with{" "}
        <span className="font-semibold">{storage.custodian}</span> at{" "}
        <span className="font-semibold" data-testid="storage-note-location">{storage.location}</span>.
      </div>
      <div className="text-xs text-muted-foreground leading-relaxed" data-testid="storage-note-cost">
        Storage &amp; insurance runs {storage.monthly_rate_pct}% of value a month —{" "}
        <span className="numeric font-semibold text-foreground">{fmtUSDStrict(monthly)}</span> on this order,
        collected from your USD wallet at the start of each month and free while your whole holding
        stays under {fmtUSDStrict(storage.waiver_usd || 100)}.
      </div>
    </div>
  );
};
